import { render } from "./OrderProcessing.vue?vue&type=template&id=11d34d29&scoped=true"
import script from "./OrderProcessing.vue?vue&type=script&lang=js"
export * from "./OrderProcessing.vue?vue&type=script&lang=js"

import "./OrderProcessing.vue?vue&type=style&index=0&id=11d34d29&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d34d29"]])

export default __exports__